import Vue from 'vue'

// Única fuente de verdad para el país activo, el catálogo de países y el
// prefijo telefónico (MOOV-5197). Todas las lecturas/escrituras de src/
// pasan por este módulo; los antiguos globals window.country /
// window.countries / window.phonePrefix ya no existen.
const state = Vue.observable({
  country: null,
  countries: [],
  phonePrefix: ''
})

export function getCountry() {
  return state.country
}

export function setCountry(isoCode) {
  state.country = isoCode
}

export function getCountries() {
  return state.countries
}

export function setCountries(countries) {
  state.countries = countries
}

export function getPhonePrefix() {
  return state.phonePrefix
}

export function setPhonePrefix(prefix) {
  state.phonePrefix = prefix
}

export default state
